module.exports = __webpack_public_path__ + "media/images/globe-e5f74bc7b39d0b17423d21779cc80554.png";